var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDownloadHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "#06255C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1534 43.8432L43.7645 50.4543M43.7645 50.4543L50.3756 43.8432M43.7645 50.4543V35.2488C43.7645 32.9503 43.7645 31.801 42.8546 30.5143C42.2501 29.6593 40.5095 28.6041 39.4719 28.4636C37.9102 28.252 37.3172 28.5613 36.1311 29.1801C30.8454 31.9374 27.2368 37.4689 27.2368 43.8432C27.2368 52.9712 34.6365 60.3709 43.7645 60.3709C52.8925 60.3709 60.2922 52.9712 60.2922 43.8432C60.2922 37.7256 56.9685 32.3843 52.0284 29.5266",
    stroke: "white",
    strokeWidth: 3.55263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownloadHover);
export default __webpack_public_path__ + "static/media/circle-download-hover.23c99bfa0cedaaf1c99ad41a55e03570.svg";
export { ForwardRef as ReactComponent };